import React from 'react';
import Reflux from 'reflux';
import {hashHistory, withRouter} from 'react-router';
import {Icon, Button, Menu, Dropdown, message, Tag} from 'antd';
import {DmsTab, TableView, AdvanceFormNew} from 'Components';
import {list} from '../../service/channelFunc';
// import {fetchChannelList} from '../../service/home';
// import {getList, enableCtrl, disableCtrl} from './mockdata'

class InfoReadList extends Reflux.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['公告'],
            key: 0,
            rows: [],
            total: 0,
            searchObj: {
                title: '',
                isShow: '',
                isPublish: '1',
                type: '',
                startDate: '',
                endDate: '',
                p: 1,
                s: 10,
            },
            loading: true
        };

        this.pageChange = this.pageChange.bind(this);
        this.goView = this.goView.bind(this);
        this.getData = this.getData.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getData();
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    //请求数据
    getData() {
        this.setState({loading: true})
        list(this.state.searchObj).then(result => {
            if (result.status && result.code == 200) {
                this.setState({
                    rows: result.data,
                    total: result.total,
                    loading: false
                })
            } else {
                message.error(result.message);
                this.setState({loading: false});
            }
        })
    }

    //页面跳转
    goView(url) {
        hashHistory.push(url);
    }

    pageChange = (page, pageSize) => {
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            this.getData();
        });
    }

    advanceReset() {
        const self = this;
        this.setState({
                filterBoxVisible: false,
                searchObj: {
                    ...this.state.searchObj,
                    title: '',
                    isShow: '',
                    isPublish: '1',
                    type: '',
                    startDate: '',
                    endDate: '',
                    p: 1,
                    s: 10
                }
            },
            function () {
                self.getData();
            })
    };

    advanceSubmit(form) {
        const self = this;
        this.setState({filterBoxVisible: false, searchObj: {...this.state.searchObj, p: 1}}, function () {
            self.getData();
        });
    };

    setFilterParam(name, value) {
        if (name === 'shipTime') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    startDate: value.from,
                    endDate: value.end
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    render() {
        const {opts, rows, total, searchObj, loading} = this.state;

        const advanceProps = {
            fileds: [
                {
                    name: 'title',
                    label: '主题',
                    text: '请输入主题',
                    type: 'default',
                    defaultValue: searchObj.title
                },
                {
                    name: 'shipTime',//startCreatedDate, endCreatedDate
                    label: '发布时间',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.startDate || '',
                        end: searchObj.endDate || ''
                    }
                },
                {
                    name: 'type',
                    label: '分类',
                    text: '选择分类',
                    options: [
                        {value: '', text: '所有'},
                        {value: '1', text: '政策公告'},
                        {value: '2', text: '产品公告'},
                        {value: '3', text: '促销公告'},
                        {value: '4', text: '其他公告'},
                        {value: '5', text: '新品发布'},
                        {value: '6', text: '调价公告'}
                    ],
                    multiple: false,
                    type: 'select',
                    defaultValue: searchObj.type
                },
                {
                    name: 'isShow',
                    label: '是否头条',
                    text: '选择是否头条',
                    options: [
                        {value: '', text: '所有'},
                        {value: '1', text: '是'},
                        {value: '0', text: '否'}
                    ],
                    multiple: false,
                    type: 'select',
                    defaultValue: searchObj.isShow
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };

        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: this.state.searchObj.p,//当前页码
                pageSize: this.state.searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [{
                title: '主题',
                dataIndex: 'title',
                render: (text, record, index) => {
                    return <a href={`#/channelFunc/${record.id}`}>{text}</a>
                }
            }, {
                title: '分类',
                dataIndex: 'typeText'
            }, {
                title: '是头条',
                dataIndex: 'isShow',
                render: text => text === 1 ? '是' : '否'
            }, {
                title: '浏览/评论/转发',
                dataIndex: 'commentCount',
                render: (text, record, index) => {
                    return `${record.clickCount}/${record.commentCount}/${record.forwardCount}`
                }
            }, {
                title: '发布时间',
                dataIndex: 'publishDate',
                render: (text, record, index) => {
                    const def = (+new Date()) - (+new Date(text));
                    const day = Math.floor(def / (3600 * 24 * 1000));
                    return (
                        <div>
                            <span>{text}</span>
                            {day <= 5 ? <Tag color="red" style={{float: 'right', cursor: 'default'}}>New</Tag> : null}
                        </div>
                    )
                }
            }],
            rows
        };
        return <div className='dms-body'>
            <DmsTab options={opts} defaultKey={0}>
            </DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps} />
                </div>
            </div>
            <div className="dms-table-box">
                <TableView {...tableViewProps} />
            </div>
        </div>

    }
}
;
export default withRouter(InfoReadList);




// WEBPACK FOOTER //
// ./src/routes/infoRead/list.js